<div class="dialogContainer">
  <div class="header">
    <h2>{{ isAddQuote() ? 'Create Parts Quote' : 'Add Parts To ' + entity.id.entityId + ';' + entity.id.entityRevision }}</h2>
  </div>
  <div class="content">
    <div>
      <input class="standardTextBox searchInput" [(ngModel)]="searchTerm" placeholder="Enter search value" (keyup.enter)="search()" />
      <input class="standardTextBox orderYearInput"
        type="number" [(ngModel)]="orderYear" placeholder="Order year"
        title="Order data defaults to most recent orders.  Please provide a year to search for older order/unit data" (keyup.enter)="search()" />
      @if (warrantyAvailable()) {
        <label for="warrantyCheckBox">Warranty</label>
      }
      @if (warrantyAvailable()) {
        <input class="checkboxInput" type="checkbox" id="warrantyCheckBox" [(ngModel)]="warranty" (click)="warrantyChanged()" />
      }
      <button [disabled]="!searchTerm() || searchTerm().length < 3" class="standardButton" (click)="search()">Search</button>
      <span class="spacer"></span>
      <span>
        <button matButton="text" (click)="openHelpDialog()">
          <span>
            <mat-icon>help_outline</mat-icon>
          </span>
        </button>
      </span>
    </div>
    @if (warranty()) {
      <div>
        <textarea
          name="warrantyRequestNotesInput"
          id="warrantyRequestNotes"
          rows="4"
          class="noresize fullWidth"
          [(ngModel)]="warrantyRequestNotes"
          placeholder="Enter Warranty Notes"
          #warrantyRequestNotesInput></textarea>
      </div>
    }
    @if (searchResult()) {
      <div class="tableContainer">
        <table class="resultTable">
          <thead>
            <tr>
              <td class="headerCell tableCell">Part #</td>
              <td class="headerCell tableCell">Description</td>
              <td class="headerCell tableCell">Available</td>
              <td class="headerCell tableCell">Price</td>
              <td class="headerCell tableCell">Quantity</td>
            </tr>
          </thead>
          @for (part of searchResult().parts; track part) {
            <tr>
              <td class="tableCell">
                @if (!hasDrawing(part)) {
                  <span>
                    {{ part.partNumber }}
                  </span>
                }
                @if (hasDrawing(part)) {
                  <span>
                    <span class="fakeLink" (click)="downloadDrawing(part)">
                      {{ part.partNumber }}
                    </span>
                  </span>
                }
              </td>
              <td class="tableCell">{{ part.description }}</td>
              <td class="tableCell">{{ part.available }}</td>
              <td class="tableCell rightAligned">{{ part.price | currency: 'USD' }}</td>
              <td class="tableCell"><input type="number" min="0" class="quantityInput" [(ngModel)]="part.quantity" /></td>
            </tr>
          }
        </table>
      </div>
    }
    @if (errorMessage()) {
      <div class="errorMessage">
        {{ errorMessage() }}
      </div>
    }
  </div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <span class="busyLabel">Please Wait...</span>
      </div>
    </div>
  }
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
      <button class="warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
      <button class="primary-button" matButton="elevated" [disabled]="cannotCreateQuote()" (click)="saveAndClose()">{{ isAddQuote() ? 'Create Quote' : 'Add parts' }}</button>
    </span>
  </div>
</div>
